// ======================================================================
// File Name       : GroupDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';

class GroupDetail extends Component {
  render() {
    const { groupBySecernId, editingGroup } = this.props;
    const { groupName, groupSecernId } = editingGroup;

    return (
      <div>
        {/* Step 11.0.0 START */}
        {groupSecernId && (
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>ユーザーグループID</Col>
            <Col as={Form.Label} sm={9}>{groupSecernId}</Col>
          </Form.Group>
        )}
        {/* Step 11.0.0 END */}
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>ユーザーグループ名</Col>
          <Col as={Form.Label} sm={9}>{groupName}</Col>
        </Form.Group>
      </div>
    );
  }
}

GroupDetail.propTypes = {
  editingGroup: PropTypes.shape().isRequired,
  groupBySecernId: PropTypes.shape().isRequired,
};

export default GroupDetail;
